// @flow

// this is here so we can override it at test time.
export function addTimeout(callback: any, delay: number): TimeoutID {
    return setTimeout(callback, delay);
}
